/* istanbul ignore file */
import { DropDownFilterProps, DropDownFilter } from 'framework/list';
import PositionDropdown from '../position/input/PositionDropdown';

const EmployeePositionFilter = (props: Omit<DropDownFilterProps, 'children'>) => {
  return (
    <DropDownFilter {...props}>
      <PositionDropdown {...props} />
    </DropDownFilter>
  );
};

export default EmployeePositionFilter;
